export default "__VITE_ASSET__B9I8c_Pl__"